import { get, del, post, put } from '../../../../GlobalModules/Utility/Http'
import {
  getRequisitions,
  deleteRequisition,
  createRequisition,
  updateRequisition,
  fetchStoreHierarchy
} from '../Model/RequisitionModel'

export const getRequisitionsApi = async (filters = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      limit: filters.limit || 10,
      offset: filters.offset || 0,
      store_id: localStorage.getItem('store_id')
    }

    if (filters.sort && filters.sort.length > 0) {
      filtersObj.sort = filters.sort.map((item) => ({
        colId: item.colId,
        sort: item.sort || 'asc'
      }))
    } else {
      // Default to newest first
      filtersObj.sort = [
        {
          colId: 'id',
          sort: 'desc'
        }
      ]
    }

    if (filters.search && filters.search !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = filters.search
    }

    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    if (filters.priority) {
      filtersObj.priority = filters.priority
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}procurement/requisitions`,
      queryParams
    )
    return getRequisitions(response)
  } catch (error) {
    throw error
  }
}

export const deleteRequisitionApi = async (slack) => {
  const response = await del(`${process.env.EXTENDED_URL}procurement/requisitions/${slack}`)
  return deleteRequisition(response)
}

export const createRequisitionApi = async (data) => {
  const response = await post(`${process.env.EXTENDED_URL}procurement/requisitions`, data)
  return createRequisition(response)
}

export const updateRequisitionApi = async (slack, data) => {
  const response = await put(
    `${process.env.EXTENDED_URL}procurement/requisitions/${slack}`,
    data
  )
  return updateRequisition(response)
}

export const fetchStoreHierarchyApi = async (orgId) => {
  try {
    const response = await get(`${process.env.EXTENDED_URL}store-hierarchy/organization/${orgId}/hierarchy`)
    return fetchStoreHierarchy(response)
  } catch (error) {
    console.error('Error fetching store hierarchy:', error)
    throw error
  }
}

export const getProductCountApi = async (filters = {}) => {
  try {
    let queryParams = {}
    
    const filtersObj = {
      store_id: localStorage.getItem('store_id')
    }

    // Add date filters if provided
    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}procurement/requisitions/product-count`,
      queryParams
    )
    
   return response?.data || []
  } catch (error) {
    console.error('Error fetching product count:', error)
    throw error
  }
}

export const loadProductsForRequisitionApi = async (searchKeyword, inventoryFilters = {}) => {
  try {
    let queryParams = {}
    
    const filtersObj = {
      store_id: localStorage.getItem('requisition_store_id') || localStorage.getItem('store_id'),
      search_attr: searchKeyword,
      sort: [{ colId: 'id', sort: 'desc' }],
      is_ingredient: 1
    }
    
    // Add inventory filters if provided
    if (inventoryFilters.usage_type) {
      filtersObj.usage_type = inventoryFilters.usage_type
    }
    if (inventoryFilters.inventory_nature) {
      filtersObj.inventory_nature = inventoryFilters.inventory_nature
    }
    if (inventoryFilters.consumption_nature) {
      filtersObj.consumption_nature = inventoryFilters.consumption_nature
    }
    if (inventoryFilters.expiry_tracking) {
      filtersObj.expiry_tracking = inventoryFilters.expiry_tracking
    }
    if (inventoryFilters.batch_tracking) {
      filtersObj.batch_tracking = inventoryFilters.batch_tracking
    }
    
    queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
    queryParams.filters = JSON.stringify(filtersObj)
    
    const response = await get(
      `${process.env.EXTENDED_URL}product/list`,
      queryParams
    )
    
    const data = response?.data?.data || (Array.isArray(response?.data) ? response.data : [])
    return Array.isArray(data) ? data : []
  } catch (error) {
    console.error('Error fetching products:', error)
    return []
  }
}

export const loadBillToListApi = async (keywords = '', type = 'SUPPLIER') => {
  try {
    const normalizedType = String(type || 'SUPPLIER').toUpperCase()
    const trimmed = String(keywords || '').trim()
    if (!normalizedType) {
      return []
    }
    // API doesn't allow empty keywords, so use a single space if empty
    const body = {
      keywords: trimmed || ' ',
      type: normalizedType,
      store_id: localStorage.getItem('store_id')
    }
    const response = await post(
      `${process.env.EXTENDED_URL}common/load_bill_to_list`,
      body
    )
    return response?.data?.data || []
  } catch (err) {
    return []
  }
}

export const getRequisitionApi = async (slack) => {
  const response = await get(`${process.env.EXTENDED_URL}procurement/requisitions/${slack}`)
  return response?.data || { success: false, data: null }
}

export const exportRequisitionsApi = async (data = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      store_id: localStorage.getItem('store_id'),
      download: 'xlsx'
    }

    if (data.search && data.search !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = data.search
    }

    if (data.from_created_date) {
      filtersObj.from_created_date = data.from_created_date
    }
    if (data.to_created_date) {
      filtersObj.to_created_date = data.to_created_date
    }

    if (data.priority && data.priority !== '') {
      filtersObj.priority = data.priority
    }

    if (data.status != null && data.status !== '') {
      filtersObj.status = data.status
    }

    queryParams.filters = JSON.stringify(filtersObj)

    // Attempt export (backend may return link or raw bytes or base64 data URL)
    const response = await get(
      `${process.env.EXTENDED_URL}report/requisition`,
      queryParams
    )

    // If API returns a link in JSON
    if (response?.data?.success && response?.data?.link) {
      if (String(response.data.link).startsWith('data:')) {
        const base64Data = response.data.link.split(',')[1]
        const binaryData = atob(base64Data)
        const bytes = new Uint8Array(binaryData.length)
        for (let i = 0; i < binaryData.length; i++)
          bytes[i] = binaryData.charCodeAt(i)
        return {
          success: true,
          data: bytes.buffer,
          message: 'Export completed - converted from base64',
          filename: response.data.filename || 'requisitions_export.xlsx'
        }
      }
      return {
        success: true,
        data: response.data.link,
        message: 'Export completed - file URL provided',
        isFileUrl: true,
        filename: response.data.filename || 'requisitions_export.xlsx'
      }
    }

    // Otherwise return raw data for caller to blob-ify
    return {
      success: true,
      data: response.data,
      message: 'Export completed'
    }
  } catch (error) {
    console.error('Error exporting requisitions:', error)
    throw error
  }
}

export const updateRequisitionStatusApi = async (slack, status) => {
  try {
    const response = await put(
      `${process.env.EXTENDED_URL}procurement/requisitions/status/${slack}`,
      { status }
    )
    return (
      response?.data || { success: false, message: 'Failed to update status' }
    )
  } catch (error) {
    return (
      error?.response?.data || {
        success: false,
        message: 'Failed to update status'
      }
    )
  }
}

/**
 * Get measurement units with optional filters
 * @param {Object} filters - Optional filters for the request
 * @param {boolean} excludeStatusFilter - If true, excludes status:1 filter (used for ProductView)
 * @returns {Promise} List of measurement units
 */
export const getMeasurementUnits = async (filters = {}, excludeStatusFilter = false) => {
  // Default filters as per your requirement
  const defaultFilters = {
    sort: [{ colId: "id", sort: "desc" }]
  };

  // Only add status:1 filter if not excluded
  if (!excludeStatusFilter) {
    defaultFilters.status = 1;
  }

  // Merge default filters with provided filters
  const mergedFilters = { ...defaultFilters, ...filters };

  // Convert filters to query string
  const filtersJson = JSON.stringify(mergedFilters);
  const encodedFilters = encodeURIComponent(filtersJson);

  const response = await get(
    `${process.env.EXTENDED_URL}/measurement_unit?filters=${encodedFilters}`
  );
  return response?.data;
};
